import { getAuthService } from './index';

export const getTokenSilently = () => {
    return getAuthService().getTokenSilently();
};

export const getTokenWithPopup = () => {
    return getAuthService().getTokenWithPopup();
};

export const getIdTokenClaims = () => {
    return getAuthService().getIdTokenClaims();
};
